// extracted by mini-css-extract-plugin
export default {"variables":"\"variables.css\"","first-table-shrink-width":"1050px","mainContainer":"DamagedLostPalletsLayout_mainContainer__DAmD-","banner":"DamagedLostPalletsLayout_banner__y6ggC"};